import type { RadioTicketProps } from '../../model';
import { TicketCardV3 } from '../cards/TicketCardV3';
import { Carousel, Slide } from './common/Carousel';
import { RadioTickets } from './common/RadioTickets';

export const TicketV3 = ({ hasError, onSelect, selectedTicketType, tickets }: RadioTicketProps) => {
  return (
    <RadioTickets
      data-testid="ticket-version-3"
      hasError={hasError}
      onSelect={onSelect}
      selectedTicketType={selectedTicketType}
    >
      <Carousel version={3}>
        {tickets.map((ticket) => (
          <Slide key={ticket.ticketType} version={3}>
            <TicketCardV3 hasError={hasError} ticket={ticket} />
          </Slide>
        ))}
      </Carousel>
    </RadioTickets>
  );
};
